/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkCustomLens {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return WellArchitectedFrameworkCustomLens.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkCustomLens>): WellArchitectedFrameworkCustomLens {
        let obj = Object.assign(new WellArchitectedFrameworkCustomLens(), model);
        WellArchitectedFrameworkCustomLens.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkCustomLens>): WellArchitectedFrameworkCustomLens {
        if (!model) return null;
        return WellArchitectedFrameworkCustomLens.newInstance(<WellArchitectedFrameworkCustomLens> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkCustomLens) {
        if (!obj) return;

        models.WellArchitectedFrameworkCustomLens.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkCustomLens): boolean {
        switch (obj.__type)
        {
            case "WellArchitectedFrameworkCustomLensForAws":
                Object.setPrototypeOf(obj, models.WellArchitectedFrameworkCustomLensForAws.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof WellArchitectedFrameworkCustomLens)[] {
        return [
            models.WellArchitectedFrameworkCustomLensForAws,
        ];
    }

    fixupFields() {
    }

}
